import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles(() => ({
  container: {
    scale: 0.8,
    marginLeft: "-0.3rem",
    padding: "0 0.4rem",
    height: "1.25rem",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    background: "green",
    color: "white",
    position: "relative",
  },
  shape: {
    position: "absolute",
    width: "0.25rem",
    height: "0.25rem",
    borderWidth: "0 0.094rem 0.094rem 0",
    borderColor: "white",
    borderStyle: "solid",
    bottom: "0.125rem",
    right: "0.125rem",
  },
}));

const DriverLabel = ({ driver }) => {
  const styles = useStyles();

  if (!driver) return null;
  else
    return (
      <View
        style={{
          background: driver.colour || palette.translucentBlack,
          color: driver.textColour || palette.typography.white.high,
          display: "inline-block",
        }}
        className={styles.container}
      >
        {driver.driverCode.split("*")[1]}
        <View className={styles.shape} />
      </View>
    );
};

export default DriverLabel;
